import {
  Flex,
  View,
  ToggleGroup,
  Table,
  IconButton,
  IconToggleEndLine,
  Badge,
  Tooltip,
  IconStandardsLine,
  IconLockLine,
  IconUnlockLine,
  Pill,
} from '@smarterservices/smarter-ui';
import { useState } from 'react';
import useAppStore from '../../stores/app';

const RoomList = ({ locations }) => {
  const [showLoader, setShowLoader] = useState(false);
  const user = useAppStore((state) => state.user);

  const handleJoinRoom = async (roomSid) => {
    window.location = 'rooms/' + roomSid;
    return;
  };

  return (
    <>
      <View
        as="div"
        justifyContent="center"
        alignItems="center"
        withVisualDebug={false}
        width="100%"
      >
        {locations.map((location) => (
          <ToggleGroup
            as="div"
            width="100%"
            margin="xxx-small none"
            key={`location_${location.proctorAccountLocationSid}`}
            toggleLabel="This is the toggle button label for screenreaders"
            summary={
              <Flex justifyItems="space-between" margin="none small none none" background="secondary">
                <Flex.Item>{location.locationName}</Flex.Item>
                <Flex.Item>
                  <Tooltip
                    renderTip={`${location.activeRoomCount} rooms online`}
                    as="span"
                    offsetX={3}
                  >
                    <Badge
                      count={location.activeRoomCount}
                      variant="primary"
                      standalone
                      margin="none"
                    />
                  </Tooltip>
                </Flex.Item>
              </Flex>
            }
            defaultExpanded={locations.length === 1 ? true : false}
            background="default"
          >
            <Table caption="Top rated movies" layout="fixed" hover={true}>
              <Table.Head>
                <Table.Row>
                  <Table.ColHeader width="40%" id="Title">
                    Name
                  </Table.ColHeader>
                  <Table.ColHeader width="18%" id="Year" textAlign="center">
                    Max Capacity
                  </Table.ColHeader>
                  <Table.ColHeader width="18%" id="Rating" textAlign="center">
                    Sessions
                  </Table.ColHeader>
                  <Table.ColHeader width="18%" id="Rating" textAlign="center">
                    Proctors
                  </Table.ColHeader>
                  <Table.ColHeader
                    width="10%"
                    id="Rating"
                    textAlign="center"
                  ></Table.ColHeader>
                </Table.Row>
              </Table.Head>
              <Table.Body>
                {location.rooms.map((room) => {
                  const alreadyInRoom = room.proctors.some(
                    (proctor) => proctor.proctorAccountUserSid === user.sid
                  );


                  return (
                    <Table.Row key={`room_${room.sid}`}>
                      <Table.Cell>
                        {room.isShared ? (
                          <View as="span" margin="none x-small none none">
                            <IconUnlockLine />
                          </View>
                        ) : (
                          <View as="span" margin="none x-small none none">
                            <IconLockLine />
                          </View>
                        )}
                        {room.roomName}
                        {room.greeterOnly && (

                          <View as="span" margin="none none none x-small">
                            <Pill color="success" >
                              Greeter
                            </Pill>
                          </View>
                        )}
                      </Table.Cell>
                      <Table.Cell textAlign="center">{room.maxStudents}</Table.Cell>
                      <Table.Cell textAlign="center">
                        {room.activeSessions}
                      </Table.Cell>
                      <Table.Cell textAlign="center">
                        {room.proctors.length}
                      </Table.Cell>
                      <Table.Cell textAlign="center">
                        {!alreadyInRoom ? (
                          <IconButton
                            withBackground={false}
                            withBorder={false}
                            color="primary"
                            size="small"
                            screenReaderLabel={`Join ${room.roomName}`}
                            margin="none"
                            padding="none"
                            onClick={() => handleJoinRoom(room.sid)}
                          >
                            <IconToggleEndLine />
                          </IconButton>
                        ) : (
                          <Pill color="success">Active</Pill>
                        )}
                      </Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          </ToggleGroup>
        ))}
      </View>
      {showLoader && <PageLoader text="Joining room..." />}
    </>
  );
};

export default RoomList;
